import React from 'react';
import {
  AreaChart, Area, BarChart, Bar, LineChart, Line, ComposedChart,
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  Cell, ReferenceLine, ReferenceArea, Legend
} from "recharts";
import {
  RouteIcon, TrendingUp, Users, Activity, Crosshair, Sparkles,
  Trophy, ClipboardList, NotebookPen, Plus, Pencil, Trash2,
  ChevronDown, ChevronUp, Search, ArrowUpRight, ArrowDownRight,
  Download, Calendar, Clock, CheckCircle2, XCircle, AlertTriangle,
  Info, Zap, Brain, BarChart3, X, UserCheck, Building2,
  HeartHandshake, CalendarDays, CalendarCheck, Stethoscope,
  FlaskConical, Headphones, Receipt, Smartphone, Globe,
  HeartPulse, MessageSquare, ShoppingCart,
  CircleAlert, Lightbulb, TrendingDown, ScanSearch, Filter,
  Bell, Send, PanelLeftClose, PanelLeft, Archive, Link as LinkIcon, ExternalLink,
  History, Heart, MessageCircle, Share2, Upload, MapPin,
  ThumbsUp, ThumbsDown, EyeOff, Eye, Phone, Mail
} from "lucide-react";
import * as S from './_shared';
export default function ExecutiveView({ ctx }) {
  const {
    ACOES_INIT,
    AcaoCard,
    AcaoDetalhe,
    AcaoModal,
    C,
    CES_COLS,
    CES_ETAPAS_NAMES,
    CES_TREND,
    CIDADES_COBERTURA,
    COOP_PLANOS_MOCK,
    CSAT_COLS,
    CSAT_ETAPAS_NAMES,
    CSAT_TREND,
    Card,
    DRIVERS_CANONICOS,
    DRIVER_TO_PILLAR,
    DistBar,
    ESCALA,
    ETAPA_DRIVER_AFFINITY,
    ETAPA_HIST,
    EtCard,
    EvaChat,
    EvaChatHistory,
    EvaInsights,
    F,
    HIST_ACOES_POR_ETAPA,
    JCFG,
    JICONS,
    LOGO,
    MESES_HIST,
    META_NPS,
    MUDANCAS_DESDE_ULTIMA_VISITA,
    MiniSparkline,
    NPSAnchor,
    PC,
    PDFExportModal,
    PER,
    PER_DEFAULT_LABELS,
    PER_OPTIONS,
    PILLAR_COLORS,
    PeriodPill,
    PeriodPillBig,
    SC,
    SHORT,
    SUCESSO_BADGES,
    SUCESSO_LEVELS,
    SYS_NPS,
    Section,
    TREND_BY_AGRUP,
    TT,
    Tag,
    ULTIMA_VISITA,
    UNIMED,
    VERBATINS_POR_ETAPA,
    Z_CX,
    Zonas,
    _META_CES_TR,
    _META_CSAT_TR,
    _META_NPS_TR,
    _SYS_CES_TR,
    _SYS_CSAT_TR,
    _SYS_NPS_TR,
    diasRest,
    etSt,
    exportPDF,
    fmtDt,
    getDriverInfo,
    getDriversForEtapa,
    getPilarOf,
    getSucessoStats,
    moe,
    pctChk,
    safeGanhoPp,
    tempoRelativo,
    todayStr
  } = S;
  const {
    DATA,
    SAUDACAO_EVA,
    acaoSel,
    acoes,
    adicionarComentario,
    agrupT,
    atualizarMensagensChatEva,
    bulkApplyEtapas,
    bulkApplyGerais,
    bulkOpen,
    bulkPct,
    busca,
    cidadesAtivas,
    compartilharPlano,
    concluirWizard,
    coopBusca,
    coopComentariosAbertos,
    coopCurtidas,
    coopDriverFilter,
    coopEtapaFilter,
    coopNovoComentario,
    coopPlanos,
    d,
    db,
    dd,
    de,
    delAcao,
    desocultarNotif,
    dj,
    driverSortMode,
    ds,
    editandoMeta,
    editandoMetaEt,
    etapaDriversFilter,
    etapaHistSel,
    etapaSel,
    evaChatAtivoId,
    evaChats,
    excluirChatEva,
    filtroCidadeAberto,
    filtroResp,
    filtroSt,
    gamificacaoOn,
    hiddenLines,
    historicoEvaVisivel,
    jorGraf,
    marcarComoLida,
    marcarTodasLidas,
    metas,
    metasCardOpen,
    metasEtapas,
    modal,
    mostrarOcultos,
    naoLidas,
    nenhumaCidade,
    notifModalFiltro,
    notifModalOpen,
    notifOpen,
    notifs,
    notifsOcultas,
    notifsVisiveis,
    novoChatEva,
    ocultarNotif,
    openPublishWizard,
    pB,
    pD,
    pE,
    pJ,
    pS,
    per,
    periodoCustom,
    periodoG,
    respDropOpen,
    segHistMode,
    segIndicador,
    selecionarChatEva,
    setAcaoSel,
    setAcoes,
    setAgrupT,
    setBulkApplyEtapas,
    setBulkApplyGerais,
    setBulkOpen,
    setBulkPct,
    setBusca,
    setCidadesAtivas,
    setConcluirWizard,
    setCoopBusca,
    setCoopComentariosAbertos,
    setCoopCurtidas,
    setCoopDriverFilter,
    setCoopEtapaFilter,
    setCoopNovoComentario,
    setCoopPlanos,
    setDriverSortMode,
    setEditandoMeta,
    setEditandoMetaEt,
    setEtapaDriversFilter,
    setEtapaHistSel,
    setEtapaSel,
    setEvaChatAtivoId,
    setEvaChats,
    setFiltroCidadeAberto,
    setFiltroResp,
    setFiltroSt,
    setGamificacaoOn,
    setHiddenLines,
    setHistoricoEvaVisivel,
    setMetaEtapa,
    setMetas,
    setMetasCardOpen,
    setMetasEtapas,
    setModal,
    setMostrarOcultos,
    setNotifFeedback,
    setNotifModalFiltro,
    setNotifModalOpen,
    setNotifOpen,
    setNotifs,
    setPB,
    setPD,
    setPE,
    setPJ,
    setPS,
    setPeriodoCustom,
    setPeriodoG,
    setPrefilledAcao,
    setRespDropOpen,
    setSegIndicador,
    setStDropOpen,
    setSucessoFiltroPeriodo,
    setSucessoModalOpen,
    setTab,
    setTipoBenefAberto,
    setTipoBeneficiario,
    setVerbatinsModal,
    stDropOpen,
    sucessoFiltroPeriodo,
    sucessoModalOpen,
    tab,
    tipoBenefAberto,
    tipoBeneficiario,
    todasCidades,
    toggleCidade,
    toggleComentarios,
    toggleCoopDriver,
    toggleCurtida,
    toggleLine,
    toggleSegHist
  } = ctx;
  return (()=>{
        const top3 = [...d.evaInsights].sort((a,b)=>a.prio-b.prio).slice(0,3);
        const tipoCfg = {
          alerta:      {bg:C.redBg,    bc:C.red,    bl:"Alerta",       Icon:CircleAlert},
          oportunidade:{bg:C.greenBg,  bc:C.green,  bl:"Oportunidade", Icon:Zap},
          padrao:      {bg:C.blueBg,   bc:C.blue,   bl:"Padrão",       Icon:ScanSearch},
          predicao:    {bg:C.purpleBg, bc:C.purple, bl:"Predição",     Icon:Brain},
        };
        const jornadaCX = d.etapas.length ? Math.round(d.etapas.reduce((s,e)=>s+e.v,0)/d.etapas.length) : 0;
        const piorEtapa = d.etapas.reduce((min,e)=>e.v<min.v?e:min, d.etapas[0]);
        const melhorEtapa = d.etapas.reduce((max,e)=>e.v>max.v?e:max, d.etapas[0]);
        return <div style={{display:"flex",flexDirection:"column",gap:18}}>
          {/* Foco do período — hero */}
          <div>
            <div style={{display:"flex",alignItems:"baseline",gap:10,marginBottom:4}}>
              <span style={{fontSize:11,fontWeight:700,color:C.p500,textTransform:"uppercase",letterSpacing:"0.08em"}}>Foco do período</span>
              <span style={{fontSize:11,color:C.text4}}>· priorizado pela Eva com base em {per.resp.toLocaleString()} respondentes</span>
            </div>
            <h2 style={{margin:"0 0 4px",fontSize:22,fontWeight:700,color:C.text,letterSpacing:"-0.03em"}}>3 frentes que mais impactam o NPS agora</h2>
            <p style={{margin:0,fontSize:13,color:C.text3,lineHeight:1.6}}>Resolva as duas primeiras e o NPS deve subir entre 6 e 10 pontos no próximo período. A terceira frente já está evoluindo bem e pode virar case.</p>
          </div>

          {/* Top 3 cards */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
            {top3.map((ins,i)=>{
              const cfg = tipoCfg[ins.tipo] || tipoCfg.padrao;
              const {Icon} = cfg;
              return <Card key={i} style={{padding:"18px 18px 16px",border:`1.5px solid ${cfg.bc}30`,background:cfg.bg,display:"flex",flexDirection:"column",minHeight:240}}>
                {/* Rank + tipo */}
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{width:26,height:26,borderRadius:8,background:cfg.bc,color:"#FFFFFF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,fontWeight:700,letterSpacing:"-0.02em"}}>{i+1}</div>
                    <div style={{display:"flex",alignItems:"center",gap:5,padding:"3px 9px",background:"rgba(255,255,255,.6)",borderRadius:20,border:`1px solid ${cfg.bc}25`}}>
                      <Icon size={11} color={cfg.bc} strokeWidth={2.4}/>
                      <span style={{fontSize:10,fontWeight:700,color:cfg.bc,letterSpacing:"0.03em",textTransform:"uppercase"}}>{cfg.bl}</span>
                    </div>
                  </div>
                </div>
                {/* Title */}
                <div style={{fontSize:14,fontWeight:700,color:C.text,letterSpacing:"-0.02em",lineHeight:1.35,marginBottom:8}}>{ins.titulo}</div>
                {/* Body */}
                <p style={{margin:"0 0 12px",fontSize:12,color:C.text2,lineHeight:1.55,flex:1}}>{ins.corpo}</p>
                {/* Ação sugerida */}
                <div style={{background:"rgba(255,255,255,.7)",borderRadius:9,padding:"9px 11px",marginBottom:10,borderLeft:`3px solid ${cfg.bc}`}}>
                  <div style={{fontSize:9,fontWeight:700,color:cfg.bc,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:2}}>Próximo passo</div>
                  <div style={{fontSize:12,color:C.text,fontWeight:500,lineHeight:1.4}}>{ins.acao}</div>
                </div>
                {/* CTAs */}
                <div style={{display:"flex",gap:6}}>
                  <button onClick={()=>setTab("acoes")} style={{flex:1,background:cfg.bc,color:"#FFFFFF",border:"none",borderRadius:8,padding:"8px 10px",cursor:"pointer",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",gap:4,fontFamily:"inherit"}}>
                    Plano de ação <ArrowUpRight size={12}/>
                  </button>
                  <button onClick={()=>setTab("eva")} style={{background:"rgba(255,255,255,.7)",color:cfg.bc,border:`1px solid ${cfg.bc}40`,borderRadius:8,padding:"8px 10px",cursor:"pointer",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",gap:4,fontFamily:"inherit"}}>
                    <Sparkles size={11}/> Eva
                  </button>
                </div>
              </Card>;
            })}
          </div>

          {/* Snapshot do período */}
          <Card style={{padding:"18px 22px"}}>
            <div style={{fontSize:11,fontWeight:700,color:C.text4,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:10}}>Snapshot do período — {per.label}</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14}}>
              {[
                {l:"NPS Geral",v:d.nps,sub:`${d.npsVar>=0?"+":""}${d.npsVar} pts vs anterior`,c:d.npsVar>=0?C.green:C.red,big:true},
                {l:"Jornada CX",v:`${jornadaCX}%`,sub:`média das ${d.etapas.length} etapas`,c:C.g700,big:true},
                {l:"Melhor etapa",v:`${melhorEtapa.v}%`,sub:melhorEtapa.e,c:C.green,big:false},
                {l:"Pior etapa",v:`${piorEtapa.v}%`,sub:piorEtapa.e,c:C.red,big:false},
              ].map((k,i)=>(
                <div key={i} style={{borderRight:i<3?`1px solid ${C.border}`:"none",paddingRight:14}}>
                  <div style={{fontSize:10,color:C.text4,fontWeight:600,textTransform:"uppercase",letterSpacing:"0.04em",marginBottom:4}}>{k.l}</div>
                  <div style={{fontSize:k.big?34:22,fontWeight:700,color:k.c,letterSpacing:"-0.04em",fontFamily:F.display,lineHeight:1.05}}>{k.v}</div>
                  <div style={{fontSize:11,color:C.text3,marginTop:3,lineHeight:1.3}}>{k.sub}</div>
                </div>
              ))}
            </div>
          </Card>

          {/* Atalhos para drill-down */}
          <div>
            <div style={{fontSize:11,fontWeight:700,color:C.text4,textTransform:"uppercase",letterSpacing:"0.06em",marginBottom:8}}>Aprofundar</div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {[
                {id:"jornada",     label:"Ver jornada completa",Icon:RouteIcon},
                {id:"drivers",     label:"Drivers de impacto", Icon:Crosshair},
                {id:"tendencias",  label:"Tendências históricas",Icon:TrendingUp},
                {id:"segmentos",   label:"Segmentação",       Icon:Users},
                {id:"acoes",       label:"Plano de ação",     Icon:ClipboardList},
              ].map(({id,label,Icon})=>(
                <button key={id} onClick={()=>setTab(id)} style={{display:"flex",alignItems:"center",gap:6,background:C.surface,border:`1px solid ${C.border}`,borderRadius:10,padding:"9px 14px",cursor:"pointer",fontSize:12,fontWeight:500,color:C.text2,fontFamily:"inherit",transition:"all .15s"}}>
                  <Icon size={13} color={C.text3}/>{label} <ArrowUpRight size={12} color={C.text4}/>
                </button>
              ))}
            </div>
          </div>
        </div>;
      })();
}
